import React from "react";

const LogutIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 5.83333L13.325 7.00833L15.475 9.16667H7V10.8333H15.475L13.325 12.9833L14.5 14.1667L18.6667 10L14.5 5.83333ZM3.66667 4.16667H10.3333V2.5H3.66667C2.75 2.5 2 3.25 2 4.16667V15.8333C2 16.75 2.75 17.5 3.66667 17.5H10.3333V15.8333H3.66667V4.16667Z"
        fill="#3C3C3C"
      />
    </svg>
  );
};

export default LogutIcon;
